import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

@Pipe({
    name: 'formatRoleName',
    standalone: true
})
export class FormatRoleNamePipe extends TitleCasePipe implements PipeTransform {
    constructor() {
        super();
    }

    transform(value: string): string;
    transform(value: null | undefined): null;
    transform(value: string | null | undefined): string | null {
        if (value === null || value === undefined) {
            return '';
        }
        value = value.replace('ROLE_', '').replace(/(_+)/g, ' ').replace(/(-+)/g, ' ');
        return super.transform(value);
    }
}
